const LegalNotice = () => {
  return (
    <div >
      <p>
        <h2>Impressum</h2>

        <p>C'est la vie Live-Musik Duo</p>
        <p>Eduard Schraml</p>
        <p>
          Von-Grafenstein-Stra&szlig;e 10 &bull; 92711 Parkstein Telefon: 09602
          / 9441994
        </p>

        <p>
          E-Mail: info@duo-cestlavie.de
          <br />
          Internet: www.duo-cestlavie.de
        </p>

        <p>
          Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a
          Umsatzsteuergesetz: DE 256458322
        </p>
        <p>
          Inhaltlich Verantwortlicher gem&auml;&szlig; &sect; 55 Abs. 2 RStV:
          Eduard Schraml (Anschrift wie oben)
        </p>
        <p>
          Haftungshinweis: Trotz sorgf&auml;ltiger inhaltlicher Kontrolle
          &uuml;bernehmen wir keine Haftung f&uuml;r die Inhalte externer Links.
          F&uuml;r den Inhalt der verlinkten Seiten sind ausschlie&szlig;lich
          deren Betreiber verantwortlich.
        </p>
      </p>
      <div style={{ height: "1px" }}/>
    </div>
  );
};

export default LegalNotice;
